import React, { createContext, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import httpService from "../../common/http.service";
export const allHolidaysContext = createContext();

function HolidaysContext({ children }) {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { i18n } = useTranslation();
  const data_language = i18n.language.toUpperCase();
  const [year, setYear] = useState(2025);
  const url = `panchang/holiday?app_language=EN&data_language=${data_language}&year=${year}`;
  const goToNextYear = () => {
    setYear((prev) => (prev < 2026 ? prev + 1 : prev));
  };

  const goToPreviousYear = () => {
    setYear((prev) => (prev > 2025 ? prev - 1 : prev));
  };

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await httpService.get(url);
        console.log("holidays:",response.data);
        setHolidays(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchHolidays();
  }, [data_language, year]);
  
  return (
    <allHolidaysContext.Provider value={{ holidays, loading, error, year, goToNextYear, goToPreviousYear }}>
      {children}
    </allHolidaysContext.Provider>
  );
}

export default HolidaysContext;
